module.exports = "/images/bp_logo.svg?2cdeb2884ca2381cde5ca21f45f6478e";